import * as pageName from "store/actions/pageAction";

export default (state = {}, action) => {
  switch (action.type) {
    case pageName.PAGE_ACTIVITY_TREE_VIEW:
    case pageName.PAGE_ACTIVITY_CLIENT_INFO:
    case pageName.PAGE_ACTIVITY_BULK_REVIEW:
    case pageName.PAGE_ACTIVITY_ACCURACY:
      return {
        ...state,
        payload: action.payload
      };
    default:
      return state;
  }
};
